import { observable, reaction, computed, action, makeObservable, values, runInAction, toJS } from 'mobx'
import { parseShape, wrapPromise } from './utils';
import { GET_ALL_FAQ, GET_ALL_LOOT_FAQ } from 'api/graphql/faq';

class FAQStore {

    consultationsFAQ = [];
    shopFAQ = [];

    loading = false;

    constructor(model) {
        this.model = model;
        makeObservable(this, {
            consultationsFAQ: observable,
            shopFAQ: observable,
            loading: observable
        })
    }

    get consultationsFAQData() {
        return wrapPromise(this.getFAQ())
    }

    get lootFAQData() {
        return wrapPromise(this.getLootFAQ());
    }

    getFAQ() {
        return this.model.apollo.query( { query: GET_ALL_FAQ })
            .then((response) => {
                const consultationsData = response.data;
                runInAction(() => {
                    this.consultationsFAQ = parseShape(consultationsData)['allFaq'].filter(item => item.isActive);
                });
                return this.consultationsFAQ;
        });
    }

    getLootFAQ() {
        return this.model.apollo.query( { query: GET_ALL_LOOT_FAQ })
            .then((response) => {
                const shopData = response.data;
                runInAction(() => {
                    this.shopFAQ = parseShape(shopData)['allLootFaq'].filter(item => item.isActive);
                });
                return this.shopFAQ;
            });
    }

}

export default FAQStore;
